import React from 'react'
import { useLocation } from 'react-router-dom'
import { ROUTES } from '../constants/Routing'

const useLogo = props => {
  const { fontSize, login, header, sidebar } = props || {}
  const location = useLocation()
  const { pathname } = location || {}
  const adminMode = pathname.includes(ROUTES.ADMIN_ROOT)
  const adminLogin = pathname.includes(ROUTES.ADMIN_LOGIN)

  const logo = {
    lndata: <div style={{ fontSize, margin: '4px 0' }}>Ln {'\u007B'} 360&deg; {'\u007d'}</div>,
    admin: <img style={{ margin: '4px 0' }} src={login || header ? '/LogoBlack.png' : '/Logo.png'} alt="LndataAdmin" />,
    cht: <img
      src={sidebar ? '/CHT_white.png' : login ? '/CHT.png' : '/CHT_text.png'}
      alt="CHT"
      style={{ height: sidebar ? '55px' : login ? '110px' : '24px' }}
    />
  }

  const isChtDomain = window.location.host === 'invoice360.lndata.com'
  return logo[process.env.REACT_APP_LOGO] ||
    (isChtDomain ? logo.cht : (adminMode && !adminLogin ? logo.admin : logo.lndata))
}

export default useLogo
